import React, { useEffect, useState } from "react";
import "./index.scss";
import InsuranceDetails from "./components";
import Button from "../../../../components/common/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  buyNow,
  ordersDetails,
  paymentSummary,
} from "../../../../utils/router/constant";
import {
  formatAmount,
  renderOrderStatus,
  renderStatus,
  setParamsInURL,
  getCodeFromUrl,
} from "../../../../utils/helper";
import { AG_CODE } from "../../../../utils/commonConstant";
import { ArrowRightPrimary } from "../../../../assets/images/svg/svg";
import PolicyEraImg from "../../../../assets/images/image 1 (1).png";
import Card from "../../../../components/cardView";

const OrderCard = ({ orderDetail }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [link, setLink] = useState("");
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const agCode = getCodeFromUrl();
  const toggleDetailsVisibility = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };

  useEffect(() => {
    const generateLink = async () => {
      // Await the result of setParamsInURL, which is an async function
      const params = await setParamsInURL(location, {
        orderId: orderDetail.entityid,
      });
      setLink(`${ordersDetails}?${params}`);
    };

    // Trigger link generation if orderDetail changes
    if (orderDetail) {
      generateLink();
    }
  }, [orderDetail]);

  // const handleOrderContinue = async (orderData) => {
  //   if (!orderData || !orderData.status) return "";
  //   let path = buyNow;
  //   let paramObject = {
  //     entityid: orderData.product_id,
  //     orderId: orderData.entityid,
  //   };
  //   if (orderData.product_type_name === "UMBRELLA") {
  //     switch (orderData.status) {
  //       case "PROPOSAL_PENDING":
  //         paramObject.tabIndex = 0;
  //         break;
  //       case "PAYMENT_PENDING":
  //         path = paymentSummary;
  //         break;
  //       case "PAYMENT_FAILED":
  //         path = paymentSummary;
  //       case "PAYMENT_SUCCESS":
  //         paramObject.tabIndex = 0;
  //         break;
  //       default:
  //         return "";
  //     }
  //   } else {
  //     switch (orderData.status) {
  //       case "PROPOSAL_PENDING":
  //         paramObject.tabIndex = 0;
  //         break;
  //       case "PAYMENT_PENDING":
  //         if (orderDetail.proposal_filled === 0) {
  //           paramObject.tabIndex = 0;
  //         } else {
  //           path = paymentSummary;
  //         }
  //         break;
  //       case "PAYMENT_FAILED":
  //         path = paymentSummary;
  //         break;
  //       default:
  //         return "";
  //     }
  //   }

  //   const params = await setParamsInURL(location, paramObject);
  //   navigate(`${path}?${params}`);
  // };

  const handleOrderContinue = async (orderData) => {
    if (!orderData || !orderData.status) return "";
    let path = buyNow;
    let paramObject = {
      entityid: orderData.product_id,
      orderId: orderData.entityid,
    };
    if (agCode?.toLowerCase() === AG_CODE || agCode?.toLowerCase() === "chem") {
      switch (orderData.status) {
        case "PAYMENT_PENDING":
        case "PAYMENT_FAILED":
          path = paymentSummary;
          break;
        case "PROPOSAL_PENDING":
        case "PAYMENT_SUCCESS":
        case "COMPLETED":
          path = buyNow;
          paramObject.tabIndex = 0;
          break;
        default:
          return "";
      }
    } else if (orderData.product_type_name === "UMBRELLA" && orderData.redirect_url) {
      switch (orderData.status) {
        case "PROPOSAL_PENDING":
          paramObject.tabIndex = 0;
          break;
        case "PAYMENT_PENDING":
          window.location.href = `${orderData.redirect_url}`;
          return;
        case "PAYMENT_FAILED":
          window.location.href = `${orderData.redirect_url}`;
          return;
        case "PAYMENT_SUCCESS":
          paramObject.tabIndex = 0;
          break;
        default:
          return "";
      }
    } else {
      switch (orderData.status) {
        case "PROPOSAL_PENDING":
          paramObject.tabIndex = 0;
          break;
        case "PAYMENT_PENDING":
          if (orderDetail.proposal_filled === 0) {
            paramObject.tabIndex = 0;
          } else {
            path = paymentSummary;
          }
          break;
        case "PAYMENT_FAILED":
          path = paymentSummary;
          break;
        default:
          return "";
      }
    }

    const params = await setParamsInURL(location, paramObject);
    navigate(`${path}?${params}`);
  };

  const headerContent = (
    <>
      {/* {orderDetail.product_type_name === "UMBRELLA" ? (
        <img
          src={
            orderDetail?.product_details[0].media_url
              ? orderDetail?.product_details[0].media_url
              : PolicyEraImg
          }
          className="product-variant-image"
          alt="Product Variant"
        />
      ) : (
        orderDetail.product_details.map((variant, index) => (
          <img
            key={index}
            src={variant.media_url ? variant.media_url : PolicyEraImg}
            className="product-variant-image"
            alt="Product Variant"
          />
        ))
      )} */}

      {orderDetail.oems.map((variant, index) => (
        <img
          key={index}
          src={variant.media_url ? variant.media_url : PolicyEraImg}
          className="product-variant-image"
          alt="Product Variant"
        />
      ))}
    </>
  );

  const bodyContent = (
    <div className="insurance--order--content">
      <div className="status-container">
        <div className="insurance--status">
          {renderStatus(orderDetail?.status)}
        </div>
        <div className="proposal--status">
          {renderOrderStatus(orderDetail?.proposal_filled)}
        </div>
      </div>
      <div className="insurance--card--data">
        <div className="card--content--subtitle">#{orderDetail.code}</div>
        <div className="card--content--subtitle">
          {orderDetail.created_date}
        </div>
      </div>
      <div className="insurance--card--data">
        <div className="card--content--title">{orderDetail.name}</div>
        <div className="card--content--title">
          {formatAmount(orderDetail.gross_amount)}
        </div>
      </div>
    </div>
  );

  const footerContent = (
    <div>
      {isDetailsVisible &&
        orderDetail.product_details.map((variant, index) => (
          <InsuranceDetails key={index} product={variant} />
        ))}
      <div className="insurance--footer--button">
        <Link to={link} className="view--link">
          View Details <ArrowRightPrimary />
        </Link>
        {(orderDetail.status === "PAYMENT_PENDING" ||
          orderDetail.status === "PROPOSAL_PENDING" ||
          orderDetail.status === "PAYMENT_FAILED" ||
          ((orderDetail.status === "PAYMENT_SUCCESS" ||
            orderDetail.status === "COMPLETED") &&
            orderDetail.proposal_filled === 0)) && (
          <div>
            <Button
              type="button"
              variant="primary"
              label="Continue"
              onClick={() => handleOrderContinue(orderDetail)}
            />
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Card
      headerContent={headerContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
      toggleDetailsVisibility={toggleDetailsVisibility}
      upscale_type={"RECOMMENDED"}
    />
  );
};

export default OrderCard;
